import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "select",
    "registrationSection",
    "registrationHint",
    "registrationState",
    "registrationNumber"
  ]

  static values = {
    businessTypes: Object
  }

  connect() {
    this.refresh()
  }

  change() {
    this.refresh()
  }

  refresh() {
    const config = this.selectedBusinessTypeConfig()
    const requiresRegistration = config?.requires_registration === true
    const regulatoryBody = config?.regulatory_body || "órgão regulador"

    if (this.hasRegistrationSectionTarget) {
      this.registrationSectionTarget.classList.toggle("d-none", !requiresRegistration)
    }

    if (this.hasRegistrationHintTarget) {
      this.registrationHintTarget.textContent = requiresRegistration
        ? `Informe o estado e o número do registro no ${regulatoryBody}.`
        : "Selecione um tipo que exija registro para liberar os campos profissionais."
    }

    if (!requiresRegistration) {
      if (this.hasRegistrationStateTarget) this.registrationStateTarget.value = ""
      if (this.hasRegistrationNumberTarget) this.registrationNumberTarget.value = ""
    }
  }

  selectedBusinessTypeConfig() {
    const selectedId = this.hasSelectTarget ? this.selectTarget.value.toString() : ""
    return this.businessTypesValue?.[selectedId] || null
  }
}
